const FAILURE_REASONS = [
  'unconfigured',
  'timeout',
  'transport_error',
  'unhealthy_response',
  'quota_limited',
] as const;

/** Closed provider failures; consumers distinguish outages from a bad control. */
export class FeatureFlagEvaluationError extends Error {
  constructor(readonly reason: (typeof FAILURE_REASONS)[number]) {
    super(reason);
    this.name = 'FeatureFlagEvaluationError';
  }
}

/** Error contracts survive duplicated module instances in CJS/ESM consumers. */
export function isFeatureFlagEvaluationError(cause: unknown): cause is FeatureFlagEvaluationError {
  if (!(cause instanceof Error) || cause.name !== 'FeatureFlagEvaluationError') return false;
  const reason: unknown = Reflect.get(cause, 'reason');
  return FAILURE_REASONS.some((value) => value === reason);
}
